import styled, { css } from "styled-components";
import { FlexMixin } from "../../../../styles/common/mixins/helpers.styled.js";
const radioButtonGroupVariants = {
    horizontal: css`
		${FlexMixin()}
		gap: 16px;
	`,
    vertical: css`
		${FlexMixin({
        direction: 'column'
    })}
		gap: 12px;
	`
};
export const RadioButtonWrapper = styled.div.withConfig({
    displayName: "styled__RadioButtonWrapper",
    componentId: "sc-3615037f-0"
})`
	/* div.searcher-multi-pak__top */
	width: 100%;

	${({ $variant  })=>$variant && radioButtonGroupVariants[$variant]}
`;

//# sourceMappingURL=styled.js.map